import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HelpersModule } from '@core/components/helpers/helpers.module';
import { LabelsModule } from '@core/components/labels/labels.module';

import { CoreCustomFormsHelpersSearchFiltersModule } from '../../helpers/filters/filters.module';
import { FillMultipleTagSelectorV1FieldComponent } from './fill-multiple-tag-selector-v1/fill-multiple-tag-selector-v1.component';
import { ViewMultipleTagSelectorV1FieldComponent } from './view-multiple-tag-selector-v1/view-multiple-tag-selector-v1.component';
import { SettingsMultipleTagSelectorV1FieldComponent } from './settings-multiple-tag-selector-v1/settings-multiple-tag-selector-v1.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HelpersModule,
        LabelsModule,
        CoreCustomFormsHelpersSearchFiltersModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    declarations: [
        FillMultipleTagSelectorV1FieldComponent,
        ViewMultipleTagSelectorV1FieldComponent,
        SettingsMultipleTagSelectorV1FieldComponent
    ],
    exports: [
        FillMultipleTagSelectorV1FieldComponent,
        ViewMultipleTagSelectorV1FieldComponent,
        SettingsMultipleTagSelectorV1FieldComponent
    ],

})
export class CoreCustomFormsFieldMultipleTagSelectorV1FieldsModule { }
